import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import buildQuery from "odata-query";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { QuotesLine } from "../../../../core/models/qoutes/quoteLine";
import { Currency } from "../../../../core/models/shared/currencyList";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { Select, SelectModule } from "primeng/select";
import { CommonModule } from "@angular/common";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

import { CheckboxChangeEvent, CheckboxModule } from "primeng/checkbox";

import { ToggleSwitchModule } from "primeng/toggleswitch";
import { ReleasedProduct } from "../../../../core/models/shared/releaseProduct";

@UntilDestroy()
@Component({
  selector: "jni-line-detail",
  templateUrl: "./line-detail.component.html",
  styleUrls: ["./line-detail.component.scss"],
  imports: [
    SelectModule,
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    ToggleSwitchModule,
    CheckboxModule,
  ],
})
export class LineDetailComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() currencyList: Currency[] = [];
  @Input() releasedProductsList: ReleasedProduct[] = [];
  @Input() sellCurrencyStatus = true;
  @Input() formErrors!: Record<string, string>;
  @Output() validationErrorEvent = new EventEmitter();

  displayPosition = false;
  position = "bottom-right";
  closable = false;
  showSmallLoader = false;
  currencyConversion?: ExchangeRatesDto;
  sellCurrencyConversion?: ExchangeRatesDto;

  showForeignCurrency = false;
  @Input() netFieldStatus = false;

  isoCurrencyCode = "";
  netReteAfterConversion = 0;
  netValueWithIcon = "";
  netConvertToUsd = "";
  netTotalPrice = "";
  netTotalPriceConverted = "";

  sellReteAfterConversion = 0;
  sellRateValueWithIcon = "";
  sellTotalPrice = "";
  sellTotalPriceConverted = "";
  sellConvertToUsd = "";
  sellIsoCurrencyCode = "";
  grossProfit = 0;
  commission = 0;

  constructor(private _samplepoListingService: SamplepoListingService) {}

  ngOnInit(): void {
    this.disabledInitialFields();
    //this.getSellCurrencyConversion('INR');
    //this.sellCurrencyStatus = true;
  }
  showPositionDialog(position: string) {
    this.position = position;
    this.displayPosition = true;
  }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  disabledInitialFields() {
    this.parent.get(["lines", "netTotalD365"])?.disable();
    this.parent.get(["lines", "currencyCodeD365"])?.disable();
    this.parent.get(["lines", "netConversion"])?.disable();
    this.parent.get(["lines", "netConversionTotal"])?.disable();
    this.parent.get(["lines", "sellTotal"])?.disable();
    this.parent.get(["lines", "sellConversion"])?.disable();
    this.parent.get(["lines", "sellConversionTotal"])?.disable();
  }

  onCurrencyEnable(event: CheckboxChangeEvent) {
    if (event.checked) {
      this.parent.get(["lines", "currencyCodeD365"])?.enable();
      this.parent.get(["lines", "purchasePriceD365"])?.disable();
      this.netFieldStatus = true;
      //this.parent.get(['lines', 'sell'])?.disable();
      this.clearCurrencyCodeRecordAndNetInForeignCurrency();
      this.showForeignCurrency = true;
    } else {
      this.parent.get(["lines", "currencyCodeD365"])?.disable();
      this.parent.get(["lines", "purchasePriceD365"])?.enable();
      //this.parent.get(['lines', 'sell'])?.enable();
      this.clearCurrencyCodeRecordAndNetInForeignCurrency();
      this.currencyConversion = undefined;
      this.showForeignCurrency = false;
      this.netFieldStatus = false;
    }
  }

  clearCurrencyCodeRecordAndNetInForeignCurrency() {
    this.parent.patchValue({
      lines: {
        currencyCodeD365: "",
        purchasePriceD365: 0,
        netTotalD365: 0,
        netConversion: "",
        netConversionTotal: "",
      },
    });
    this.netValueWithIcon = "";
    this.netConvertToUsd = "";
    this.netTotalPrice = "";
    this.netTotalPriceConverted = "";
  }

  onCurrencyConversion() {
    this.showSmallLoader = true;
    const currency = this.parent.get(["lines", "currencyCodeD365"])?.value;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });

      if (currency === "USD") {
        const checkboxControl = this.parent.get(
          "lines.isnetInForeignCurrencyStatus"
        );
        checkboxControl?.setValue(false);
        this.parent.get(["lines", "currencyCodeD365"])?.disable();
        this.parent.get(["lines", "purchasePriceD365"])?.enable();
        this.currencyConversion = undefined;
        this.showForeignCurrency = false;
        this.netFieldStatus = false;
        this.parent.patchValue({
          lines: {
            netConversion: "",
            netConversionTotal: "",
          },
        });
        this.setCurrencyCodeToUSD();
        return;
      }

      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            this.netFieldStatus = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            this.currencyConversion = sortedCurrency[0];
            if (this.currencyConversion) {
              this.patchValueInRates(this.currencyConversion.Rate.toString());
            }
            this.parent.get(["lines", "purchasePriceD365"])?.enable();
            // this.parent.get(['lines', 'sell'])?.enable();
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  @ViewChild("currencySelect") currencySelect!: Select;
  setCurrencyCodeToUSD() {
    this.parent.get(["lines", "currencyCodeD365"])?.setValue("USD");
    this.currencySelect.disabled = true;
  }

  newCurrencyConversion() {
    this.showSmallLoader = true;
    const currency = this.parent.get(["lines", "currencyCodeD365"])?.value;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            this.netFieldStatus = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });
            this.currencyConversion = sortedCurrency[0];
            if (this.currencyConversion) {
              this.patchValueInRates(this.currencyConversion.Rate.toString());
            }
            this.parent.get(["lines", "purchasePriceD365"])?.enable();
            this.netFieldStatus = true;
            this.showForeignCurrency = true;
            this.netFieldStatus = false;
            this.parent.get(["lines", "currencyCodeD365"])?.enable();
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  getSellCurrency(sellCurrency: string) {
    this.getSellCurrencyConversion(sellCurrency);
  }

  getSellCurrencyConversion(currency: string) {
    this.showSmallLoader = true;
    if (currency) {
      const filter = {
        and: [
          {
            RateTypeName: "Closing",
          },
          {
            FromCurrency: currency,
          },
          {
            ToCurrency: "USD",
          },
        ],
      };
      const query = buildQuery({ filter });
      this._samplepoListingService
        .getCurrencyConversion(query)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            const sortedCurrency = res.data.sort((a, b) => {
              if (a.EndDate > b.EndDate) {
                return -1;
              }
              if (a.EndDate < b.EndDate) {
                return 1;
              }
              return 0;
            });

            this.sellCurrencyConversion = sortedCurrency[0];
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onQuantityChange(event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    this.showSmallLoader = true;
    let quantity = eventTarget.value.toString().replace(/[^-0-9]/g, "");
    quantity = quantity.includes("-")
      ? quantity.substring(0, 10)
      : quantity.substring(0, 9);
    if (quantity) {
      this.patchValueInQuantity(quantity);
      let netPrice: string = this.parent.get([
        "lines",
        "purchasePriceD365",
      ])?.value;
      if (netPrice) {
        netPrice = netPrice.toString().replace(/[^a-zA-Z0-9.]/g, "");
        const convertedNetPrice = this.netConvertToUsd.replace(
          /[^a-zA-Z0-9.]/g,
          ""
        );
        this.patchValueInTotalNet(netPrice, convertedNetPrice);
      }
      let sellPrice: string = this.parent.get(["lines", "sell"])?.value;
      if (sellPrice) {
        sellPrice = sellPrice.toString().replace(/[^a-zA-Z0-9.]/g, "");
        const convertedSellPrice = this.sellConvertToUsd
          .toString()
          .replace(/[^a-zA-Z0-9.]/g, "");
        this.patchValueInTotalSell(sellPrice, convertedSellPrice);
      }
      this.showSmallLoader = false;
    } else {
      this.showSmallLoader = false;
      this.clearlinePriceValue();
      this.clearSellLine();
      this.patchEmptyValueInQuantity();
    }
    this.calculateGrossProfit();
  }

  patchEmptyValueInQuantity() {
    this.parent.patchValue({
      lines: {
        orderedPurchaseQuantityD365: 0,
      },
    });
  }

  patchValueInQuantity(quantity: string) {
    this.parent.patchValue({
      lines: {
        orderedPurchaseQuantityD365: parseFloat(quantity),
      },
    });
  }

  onNetConversion(event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    this.showSmallLoader = true;
    let netRate = eventTarget.value.replace(/[^.0-9.0-9]/g, "");
    const regExp = /^\d*\.?\d*$/;
    const revenue = regExp.test(netRate) ? "valid" : "invalid";
    if (revenue === "valid" && netRate !== "") {
      netRate = netRate.substring(0, 9);
      this.patchValueInNetPrice(netRate);
      if (netRate) {
        this.netValueWithIcon = netRate;
        const currency = this.parent.get(["lines", "currencyCodeD365"])?.value;
        this.isoCurrencyCode = currency;
        if (this.currencyConversion) {
          if (this.currencyConversion.Rate != 0) {
            this.netReteAfterConversion =
              parseFloat(netRate) * this.currencyConversion?.Rate;
            if (this.netReteAfterConversion.toString() != "") {
              this.netConvertToUsd = this.netReteAfterConversion.toString();
              this.patchValueInNet(this.netConvertToUsd);
            }
          }
        }
        this.patchValueInTotalNet(
          netRate,
          this.netReteAfterConversion.toString()
        );
      }
      this.calculateGrossProfit();
    } else {
      this.clearlinePriceValue();
      eventTarget.value = "";
    }

    this.showSmallLoader = false;
  }

  patchValueInNet(netConvertToUsd: string) {
    this.parent.patchValue({
      lines: {
        netConversion: netConvertToUsd,
      },
    });
  }

  patchValueInNetPrice(netPrice: string) {
    this.parent.patchValue({
      lines: {
        purchasePriceD365: parseFloat(netPrice),
      },
    });
  }

  patchValueInLines(saleorder: QuotesLine, sellCurrencyStatus: string) {
    this.isoCurrencyCode = saleorder.currencyCodeD365 ?? "";
    this.netValueWithIcon = saleorder.purchasePriceD365?.toString() ?? "";
    this.netConvertToUsd = saleorder.netConversion?.toString() ?? "";
    this.netTotalPrice = saleorder.netTotalD365?.toString() ?? "";
    this.netTotalPriceConverted =
      saleorder.netConversionTotalD365?.toString() ?? "";

    this.sellRateValueWithIcon = saleorder.sellD365?.toString() ?? "";
    this.sellTotalPrice = saleorder.sellTotalD365?.toString() ?? "";
    this.sellTotalPriceConverted =
      saleorder.sellConversionTotal?.toString() ?? "";
    this.sellConvertToUsd = saleorder.sellConversion?.toString() ?? "";
    this.sellIsoCurrencyCode = sellCurrencyStatus ?? "";
    this.grossProfit = saleorder.grossProfitD365 ?? 0;
    this.commission = saleorder.commissionD365 ?? 0;
    if (saleorder.isnetInForeignCurrencyStatus) {
      this.newCurrencyConversion();
    }
  }
  clearlinePriceValue() {
    this.parent.patchValue({
      lines: {
        purchasePriceD365: 0,
        netTotalD365: 0,
        netConversion: "",
        netConversionTotal: "",
      },
    });
    this.netTotalPrice = "";
    this.netValueWithIcon = "";
    this.netConvertToUsd = "";
    this.netTotalPriceConverted = "";

    this.clearCommissionAndGrossProfit();
  }

  clearLineForm() {
    this.isoCurrencyCode = "";

    this.netValueWithIcon = "";
    this.netConvertToUsd = "";
    this.netTotalPrice = "";
    this.netTotalPriceConverted = "";

    this.sellRateValueWithIcon = "";
    this.sellTotalPrice = "";
    this.sellTotalPriceConverted = "";
    this.sellConvertToUsd = "";
    this.sellIsoCurrencyCode = "";

    this.grossProfit = 0;
    this.commission = 0;

    this.currencyConversion = undefined;
    this.netReteAfterConversion = 0;
  }

  disabledNetConversionCurrencyField() {
    this.parent.get(["lines", "currencyCodeD365"])?.disable();
    this.parent.get(["lines", "isnetInForeignCurrencyStatus"])?.disable();
    this.netFieldStatus = true;
  }

  disabledNetField() {
    this.parent.get(["lines", "currencyCodeD365"])?.disable();
  }

  enableNetField() {
    this.netFieldStatus = false;
  }

  patchValueInTotalNet(net: string, convertedNet: string) {
    const quantity = this.parent.get([
      "lines",
      "orderedPurchaseQuantityD365",
    ])?.value;
    if (quantity) {
      const netprice = parseFloat(net) * parseInt(quantity);
      this.netTotalPrice = netprice.toString();
      const netPriceCon =
        parseFloat(convertedNet == "" ? "0" : convertedNet) *
        parseInt(quantity);
      this.netTotalPriceConverted = netPriceCon.toString();
      this.patchValueInNetTotalNet(
        this.netTotalPrice,
        this.netTotalPriceConverted
      );
    }
  }

  patchValueInNetTotalNet(
    netTotalPrice: string,
    netTotalPriceConverted: string
  ) {
    this.parent.patchValue({
      lines: {
        netTotalD365: parseFloat(netTotalPrice),
        netConversionTotal: netTotalPriceConverted,
      },
    });
  }

  patchValueInRates(rates: string) {
    this.parent.patchValue({
      lines: {
        rates: parseFloat(rates),
      },
    });
  }

  onSellConversion(event: Event) {
    const eventTarget = event.target as HTMLInputElement;
    this.showSmallLoader = true;
    let sellRate = eventTarget.value.replace(/[^.0-9.0-9]/g, "");
    const regExp = /^\d*\.?\d*$/;
    const revenue = regExp.test(sellRate) ? "valid" : "invalid";
    if (revenue === "valid" && sellRate !== "") {
      sellRate = sellRate.substring(0, 9);
      this.patchValueInSellPrice(sellRate);
      if (sellRate) {
        this.sellRateValueWithIcon = sellRate;
        this.sellIsoCurrencyCode =
          this.sellCurrencyConversion?.FromCurrency ?? "";
        if (this.sellCurrencyConversion) {
          if (this.sellCurrencyConversion.Rate != 0) {
            this.sellReteAfterConversion =
              parseFloat(sellRate) * this.sellCurrencyConversion?.Rate;
            if (this.sellReteAfterConversion.toString() != "") {
              this.sellConvertToUsd = this.sellReteAfterConversion.toString();
              this.patchValueInSell(this.sellConvertToUsd);
            }
          }
        }
        this.patchValueInTotalSell(
          sellRate,
          this.sellReteAfterConversion.toString()
        );
      }
      this.calculateGrossProfit();
    } else {
      this.clearSellLine();
      eventTarget.value = "";
    }

    this.showSmallLoader = false;
  }

  clearSellLine() {
    this.parent.patchValue({
      lines: {
        sell: 0,
        sellTotal: "",
        sellConversion: "",
        sellConversionTotal: "",
      },
    });
    this.sellRateValueWithIcon = "";
    this.sellTotalPrice = "";
    this.sellTotalPriceConverted = "";
    this.sellConvertToUsd = "";
    this.clearCommissionAndGrossProfit();
  }

  clearCommissionAndGrossProfit() {
    this.parent.patchValue({
      lines: {
        commission: 0,
        grossProfit: 0,
      },
    });
    this.commission = 0;
    this.grossProfit = 0;
  }

  patchValueInSell(sellConvertToUsd: string) {
    this.parent.patchValue({
      lines: {
        sellConversion: sellConvertToUsd,
      },
    });
  }
  patchValueInSellPrice(sellPrice: string) {
    this.parent.patchValue({
      lines: {
        sell: parseFloat(sellPrice),
      },
    });
  }

  patchValueInTotalSell(sell: string, convertedSell: string) {
    const quantity = this.parent.get([
      "lines",
      "orderedPurchaseQuantityD365",
    ])?.value;

    if (quantity) {
      const sellPrice = parseFloat(sell) * parseInt(quantity);
      this.sellTotalPrice = sellPrice.toString();

      const sellPriceCon =
        parseFloat(convertedSell == "" ? "0" : convertedSell) *
        parseInt(quantity);
      this.sellTotalPriceConverted = sellPriceCon.toString();

      this.patchValueInNetTotalSell(
        this.sellTotalPrice,
        this.sellTotalPriceConverted
      );
    }
  }

  patchValueInNetTotalSell(
    sellTotalPrice: string,
    sellTotalPriceConverted: string
  ) {
    this.parent.patchValue({
      lines: {
        sellTotal: sellTotalPrice,
        sellConversionTotal: sellTotalPriceConverted,
      },
    });
  }

  calculateGrossProfit() {
    const netTotal = this.parent.get(["lines", "netTotalD365"])?.value;
    const sellTotal = this.parent.get(["lines", "sellTotal"])?.value;
    if (parseFloat(netTotal) && parseFloat(sellTotal)) {
      const grossProfit =
        ((parseFloat(sellTotal) - parseFloat(netTotal)) /
          parseFloat(sellTotal)) *
        100;
      const grossProfitRound = grossProfit.toFixed(2).toString();
      this.grossProfit = parseFloat(grossProfitRound);
      this.parent.patchValue({
        lines: {
          grossProfit: parseFloat(grossProfitRound),
        },
      });
      const commission = (parseFloat(sellTotal) - parseFloat(netTotal)) * 0.5;
      const commissionRound = commission.toFixed(2).toString();
      this.commission = parseFloat(commissionRound);
      this.parent.patchValue({
        lines: {
          commission: parseFloat(commissionRound),
        },
      });
    } else {
      this.grossProfit = 0;
      this.parent.patchValue({
        lines: {
          grossProfit: 0,
        },
      });
      this.commission = 0;
      this.parent.patchValue({
        lines: {
          commission: 0,
        },
      });
    }
  }

  applyVendorSkuLengthValidation(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      this.parent.patchValue({
        lines: {
          externalItemNumberD365: target.value.substring(0, 40),
        },
      });
    }
  }
}
